/* eslint-disable no-console */
const METRICS_PERFORMANCE_TIMER_LABEL = "Metrics Timer";
/**
 * Checkout the docs to understand how to measure and log your tests
 * https://nuorder-inc.atlassian.net/l/cp/vgWP11mk
 */
export const metricsTimerEnd = () => {
    if (process.env.NODE_ENV === "development") {
        setTimeout(() => {
            console.timeEnd(METRICS_PERFORMANCE_TIMER_LABEL);
        }, 0);
    }
};

export const metricsTimerStart = () => {
    if (process.env.NODE_ENV === "development") {
        console.time(METRICS_PERFORMANCE_TIMER_LABEL);
    }
};
